import env from "../../../tools/Environment";
import ep from "../../EpConst";

/**
 * Default auth service config for chronos projects.
 * if you want to change some params for ALL Chronos projects, you should do it there
 *
 */

//TODO some docs for special params
export default {
  oauth: {
    common: {
      user: {
        profile_storage_key: "chronos_profile_id",
        origin_storage_key: "chronos_origin",
        new_user_storage_key: "chronos_new_user",
        new_user_already_processed_storage_key: "chronos_new_user_already_processed",
        auto_reg_cookie: "chronos_auto_reg",
        finish_reg_param: "finish_reg",
      },
    },
    [env.MAILRU]: {
      project_reg: {
        is_auto_reg_enabled: false,
        is_auto_accept_terms: false,
        is_subscribe_disabled: false,
      },
      referral: {
        enabled: false,
        url_param: "ref",
        cookie_param: "ref",
      },
      social_ep_list: [
        ep.EP_MAILRU,
        ep.EP_VK,
        ep.EP_OK,
        ep.EP_FB,
        ep.EP_TWITTER,
        ep.EP_GOOGLE,
        ep.EP_TWITCH,
      ],
    },
    [env.MYGAMES]: {
      project_reg: {
        is_auto_reg_enabled: true,
        is_auto_accept_terms: true,
        is_subscribe_disabled: false,
      },
      referral: {
        enabled: false,
        url_param: "ref",
        cookie_param: "ref",
      },
      social_ep_list: [
        ep.EP_FB,
        ep.EP_TWITTER,
        ep.EP_STEAM,
        ep.EP_MAILRU,
        ep.EP_VK,
        ep.EP_OK,
        ep.EP_GOOGLE,
        ep.EP_TWITCH,
      ],
    },
    [env.VKPLAY]: {
      project_reg: {
        is_auto_reg_enabled: false,
        is_auto_accept_terms: false,
        is_subscribe_disabled: false,
      },
      referral: {
        enabled: false,
        url_param: "ref",
        cookie_param: "ref",
      },
      social_ep_list: [
        ep.EP_MAILRU,
        ep.EP_VK,
        ep.EP_OK,
        ep.EP_FB,
        ep.EP_TWITTER,
        ep.EP_GOOGLE,
        ep.EP_TWITCH,
      ],
    },
  },
};
